export default "__VITE_ASSET__9df622d4__"